import { getFirstPartLink } from './helpers/firstPartCopyLinkHelper';

export type ModuleType = 'sale' | 'auction' | 'tender' | 'bailiff-notice' | 'cooperative' | 'rent';

export const generateSingleOfferLink = (encryptedId: string, module: ModuleType, offerType?: string) => {
    const baseUrl = getFirstPartLink();

    return `${baseUrl}/${module}/${offerType ? `${offerType}/` : ''}${encryptedId}`;
};
